import React, { FC, ReactNode } from 'react'
import styles from './PolaroidList.module.scss'
import Polaroid, { PolaroidSpecificPageProps } from './Polaroid'
import { SAArtwork } from 'types/Artwork'
import { PolaroidCompleteSkeleton } from './components/PolaroidSkeleton'
import classNames from 'classnames'
import useQA from 'hooks/useQA'

type PolaroidListProps = PolaroidSpecificPageProps & {
  artworks: ReadonlyArray<SAArtwork>
  isLoading?: boolean
  isArtistNameVisible?: boolean
  skeletonQuantity?: number
  userID?: number
  isUsersArtworksAccount?: boolean
  customStyle?: string
  isMediumMaterialVisible?: boolean
  customPriceElement?: (artwork: SAArtwork) => JSX.Element
  customPromoCode?: string
}

const PolaroidList: FC<PolaroidListProps> = ({
  artworks,
  algoliaIndice,
  algoliaUserToken,
  eventType,
  dataApi,
  dataList,
  dataListId,
  dataListName,
  isLoading = false,
  skeletonQuantity = 6,
  isArtistNameVisible = true,
  userID,
  isMediumMaterialVisible,
  isUsersArtworksAccount,
  customStyle = '',
  customPriceElement,
  customPromoCode,
}) => {
  const { testId } = useQA()
  if (isLoading) {
    return (
      <div
        className={classNames(styles.polaroidListContainer, {
          [customStyle]: customStyle !== '',
        })}
        {...testId('polaroid-list-container-loading')}
      >
        {Array.from({ length: skeletonQuantity }, (_, index) => (
          <PolaroidCompleteSkeleton key={index.toString()} />
        ))}
      </div>
    )
  }

  if (!artworks?.length) {
    return null
  }

  return (
    <div
      className={classNames(styles.polaroidListContainer, {
        [customStyle]: customStyle !== '',
      })}
      {...testId('polaroid-list-container')}
    >
      {artworks.map((artwork, index) => {
        const priority = index === 0
        const lazyLoad = index > 3
        const isImageSrcFromProd = index < 6
        return (
          <Polaroid
            key={artwork.artworkId}
            artwork={artwork}
            eventType={eventType}
            algoliaIndice={algoliaIndice}
            algoliaUserToken={algoliaUserToken}
            dataApi={dataApi}
            dataList={dataList}
            dataListId={dataListId}
            dataListName={dataListName}
            isArtistNameVisible={isArtistNameVisible}
            priority={priority}
            lazyLoad={lazyLoad}
            isImageSrcFromProd={isImageSrcFromProd}
            userID={userID}
            isUsersArtworksAccount={isUsersArtworksAccount}
            isMediumMaterialVisible={isMediumMaterialVisible}
            customPriceElement={!!customPriceElement ? customPriceElement(artwork) : undefined}
            customPromoCode={!!customPromoCode ? customPromoCode : ''}
          />
        )
      })}
    </div>
  )
}

export default PolaroidList
